<section>  
  <ion-row class="pl-10">
    <ion-col size>
      <h6 class="m-0 font_bold">{{ !isAddressGrievance ? 'Add New ' : 'Address '}} Grievance</h6>
    </ion-col>
    <ion-col size="auto">
      <button matButton mat-dialog-close class="dialog_btns close_btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>    
  </ion-row>
  
  <mat-dialog-content class="p-10 p-md-15">
    <form [formGroup]="grievanceForm" (ngSubmit)="onSubmit()" class="form-container">
      
      <ion-row>
        
        <ion-col size="12" size-md="6" *ngIf="!isAddressGrievance">
          <mat-form-field class="w-100 mat-height40 mb-10 mat-input-style">
            <mat-select formControlName="grievanceType" placeholder="Grievance Type" class="font_regular">
              <mat-option *ngFor="let type of grievanceTypes" [value]="type.key">{{ type.value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="grievanceForm.get('grievanceType')?.hasError('required')">Grievance Type is required</mat-error>
          </mat-form-field>          
        </ion-col>
        
        <ion-col size="12" size-md="6" *ngIf="getAllEmpData.length > 0 && !isAddressGrievance">  
          <mat-form-field class="w-100 mat-height40 mb-10 mat-input-style">
            <mat-select formControlName="againstWhom" placeholder="Against Whom" class="font_regular">
              <mat-option *ngFor="let against of getAllEmpData" [value]="against">{{ against.firstName}} {{ against.lastName }}</mat-option>
            </mat-select>
            <mat-error *ngIf="grievanceForm.get('againstWhom')?.hasError('required')">Against Whom is required</mat-error>
          </mat-form-field>
        </ion-col>
        
        <ion-col size="12" size-md="6" *ngIf="getAllEmpData.length > 0 && !isAddressGrievance">
          <mat-form-field class="w-100 mat-height40 mb-10 mat-input-style">
            <mat-select formControlName="whomToSent" placeholder="Whom To Sent" class="font_regular">
              <mat-option *ngFor="let whom of getAllEmpData" [value]="whom">{{ whom.firstName}} {{ whom.lastName }}</mat-option>
            </mat-select>
            <mat-error *ngIf="grievanceForm.get('whomToSent')?.hasError('required')">Whom To Sent is required</mat-error>
          </mat-form-field>  
        </ion-col>
        
        <ion-col size="12" size-md="6" *ngIf="!isAddressGrievance">
          <mat-form-field class="w-100 mat-height40 mb-10 mat-input-style">
            <mat-select formControlName="priority" placeholder="Priority" class="font_regular">
              <mat-option *ngFor="let p of priorities" [value]="p">{{ p }}</mat-option>
            </mat-select>
            <mat-error *ngIf="grievanceForm.get('priority')?.hasError('required')">Priority is required</mat-error>
          </mat-form-field>
        </ion-col>
        
        <ion-col size="12" *ngIf="!isAddressGrievance">
          <mat-form-field class="w-100 mat-input-style mb-20">
            <textarea matInput rows="3" formControlName="reason" placeholder="Reason" class="font_regular"></textarea>
            <mat-error *ngIf="grievanceForm.get('reason')?.invalid && grievanceForm.get('reason')?.dirty">
              <span *ngIf="grievanceForm.get('reason')?.hasError('required')">Reason is required</span>
              <span *ngIf="grievanceForm.get('reason')?.hasError('maxlength')">Maximum 255 characters allowed</span>
            </mat-error>
          </mat-form-field>
        </ion-col>
        
        
        <ion-col size="12" size-md="6" *ngIf="isAddressGrievance">
          <mat-form-field class="w-100 mat-height40 mb-10 mat-input-style">
            <mat-select formControlName="status" placeholder="Status" class="font_regular">
              <mat-option *ngFor="let status of statusType" [value]="status.key">{{ status.value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="grievanceForm.get('status')?.hasError('required')">Status is required</mat-error>
          </mat-form-field>
        </ion-col>
        
        <ion-col size="12" *ngIf="isAddressGrievance">
          <mat-form-field class="w-100 mat-input-style mb-20">
            <textarea matInput rows="3" formControlName="commentFromReceiver" placeholder="Add Comment" class="font_regular"></textarea>
            <mat-error *ngIf="grievanceForm.get('commentFromReceiver')?.invalid && grievanceForm.get('commentFromReceiver')?.dirty">
              <span *ngIf="grievanceForm.get('commentFromReceiver')?.hasError('required')">Reason is required</span>
              <span *ngIf="grievanceForm.get('commentFromReceiver')?.hasError('maxlength')">Maximum 255 characters allowed</span>
            </mat-error>
          </mat-form-field>
        </ion-col>
        
        
        <ion-col size="12">
          <ion-button mat-raised-button type="submit" class="form-submit-btn" [disabled]="grievanceForm.invalid">Submit</ion-button>
        </ion-col>
      </ion-row>
    </form>
    
  </mat-dialog-content>
</section>